<template>
  <div class="box12">
    <pageTitle title="常见问题" />

    <commomProblem :problemData="problemData" :styleData="styleData" />
    <div class="btn" @click="zixun('了解更多课程详情')">了解更多课程详情</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "大家都来学新媒体，行业会不会饱和？",
          answer: [
            "数字经济时代大量实体企业需要转型线上，现阶段正处于行业人才紧缺阶段，急需新媒体+短视频直播运营人才助力企业赋能。",
          ],
        },
        {
          title: "课程需要学习多久？",
          answer: [
            "学习课程内容+利用自己账号的实际练习大致2-3个月，即可完成学习。",
          ],
        },
        {
          title: "30岁转行新媒体还来得及么？",
          answer: [
            "新媒体+短视频直播运营属于经验类学科， 其操作类难度系数很低。只要能把对应的概念理解透彻，学习都是没有问题的。五六十岁学习后做副业的也大有人在。",
          ],
        },
        {
          title: "学不会怎么办？",
          answer: ["可以先去试听课程内容，确定可以学习后再报名。"],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/newMedia/box12/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("新媒体+短视频-就业课","了解更多课程详情",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.box12 {
  padding: 80px 0px 88px;
  width: 100%;
  background: #fef1ec url("../../../assets/coursePage/newMedia/box12/bgc.png")
    no-repeat;
  background-size: cover;
  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 690px;
    height: 96px;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    line-height: 96px;
    text-align: center;
    text-shadow: 2px 6px 0px #207dff;
    background: linear-gradient(180deg, #ff8932 0%, #ff2a00 100%);
    box-shadow: 0px 10px 20px 0px #ffd4cc, 0px 4px 16px 0px #fecebf;
    border-radius: 48px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 0px 6px 5px rgba(234, 49, 12, 0.77);
  }
}
</style>
